import { memo } from "react";
import Box, { type BoxProps } from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { withValue } from "../../support";

type Props = Pick<BoxProps, 'sx'> & {
    readonly name: string;
    readonly value: unknown;
};

const Column = ({ sx, name, value }: Props) => (
    <Box
        sx={{
            display: 'flex',
            gap: 1,
            ...sx
        }}
    >
        <Typography
            variant='subtitle2'
            sx={{
                color: 'text.secondary',
                textAlign: 'right',
                whiteSpace: 'nowrap'
            }}
        >
            {name}:
        </Typography>
        <Typography
            variant='subtitle1'
            sx={{
                fontWeight: 600
            }}
        >
            {withValue(String(value).trim())}
        </Typography>
    </Box>
);

export default memo(Column);
